import {AppointmentDto} from './appointmentDto';

export class AppointmentCalendarDto{
  title: string;
  start: Date;
  apptDto: AppointmentDto;

  constructor(title: string, start: Date, apptDto: AppointmentDto) {
    this.title = title;
    this.start = start;
    this.apptDto = apptDto;
  }
}

